import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CustomDatePicker from './CustomDatePicker';
import dayjs from 'dayjs';

const DEFAULT_FILTER_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'thisWeek', label: 'This Week' },
  { value: 'lastWeek', label: 'Last Week' },
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'custom', label: 'Custom Range' },
];

const ChartFilter = ({
  filterValue,
  setFilterValue,
  customRange,
  setCustomRange,
  minDate,
  maxDate = dayjs().toDate(),
  filterOptions = DEFAULT_FILTER_OPTIONS,
  startLabel = 'Start Date',
  endLabel = 'End Date',
  selectSx = {},
}) => (
  <Box display="flex" gap={2}>
    <Select
      labelId="view-select-label"
      id="view-select"
      value={filterValue}
      onChange={e => {
        const newValue = e.target.value;
        setFilterValue(newValue);
        if (filterValue === 'custom' && newValue !== 'custom') {
          setCustomRange({ start: null, end: null });
        }
      }}
      sx={{
        width: '126px',
        fontSize: '14px',
        fontWeight: 600,
        borderRadius: '8px',
        borderColor: '#F2F2F2',
        color: '#7A7A7A',
        height: '38px',
        ...selectSx,
      }}
    >
      {filterOptions.map(opt => (
        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </Select>
    {filterValue === 'custom' && (
      <Box display="flex" gap={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CustomDatePicker
            label={startLabel}
            value={customRange.start}
            onChange={date => setCustomRange(r => ({ ...r, start: date }))}
            minDate={minDate}
            maxDate={customRange.end || maxDate}
          />
          <CustomDatePicker
            label={endLabel}
            value={customRange.end}
            onChange={date => setCustomRange(r => ({ ...r, end: date }))}
            minDate={customRange.start || minDate}
            maxDate={maxDate}
          />
        </LocalizationProvider>
      </Box>
    )}
  </Box>
);

export default ChartFilter; 